import React from "react";
import SellersTable from "./SellersTable";

const ApprovedSellers = () => <SellersTable status="approve" />;

export default ApprovedSellers;
